import {create, StateCreator} from 'zustand';
import {persist} from 'zustand/middleware';
import {UserIdentity} from '@/stores/contentSubmissionOffPlatformReviewStore';

type ContentSubmissionOffPlatformIdentityState = {
  identities: Record<string, UserIdentity>;
};

const slice: StateCreator<
  ContentSubmissionOffPlatformIdentityState,
  [['zustand/persist', unknown]]
> = () => ({identities: {}});

const contentSubmissionOffPlatformIdentityStore =
  create<ContentSubmissionOffPlatformIdentityState>()(
    persist(slice, {name: 'contentSubmissionOffPlatformIdentityStore'})
  );

const setIdentity = (campaignId: string, identity: UserIdentity) =>
  contentSubmissionOffPlatformIdentityStore.setState((state) => ({
    identities: {...state.identities, [campaignId]: identity},
  }));

const getIdentity = (campaignId: string) =>
  contentSubmissionOffPlatformIdentityStore.getState().identities[campaignId] ??
  null;

export const contentSubmissionOffPlatformIdentityActions = {
  setIdentity,
  getIdentity,
};
export default contentSubmissionOffPlatformIdentityStore;
